/**
 * NOLAS 2026, application multi événement (flotte e.labriquerie.net).
 * src/i18n/fr.retrospective.ts
 *
 * Messages de la fenêtre de la Rétrospective (porte de NOLAS 9d2063a,
 * 2026-10-04) : la page s'ouvre le lendemain de l'événement pendant une
 * durée réglable au back-office (event.retrospective_offset_days et
 * event.retrospective_duration_days, migration V132). Jetons d'identité
 * ({eventTypeOf}) lus dans l'événement en base, aucune date en dur.
 * Fusionné dans fr.ts, contrôlé par fr.subcatalogs.test.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesRetrospectiveFr: Record<string, string> = {
  'retrospective.window.notYet':
    'La rétrospective {eventTypeOf} sera disponible à partir du {date}.',
  'retrospective.window.closed':
    'La rétrospective {eventTypeOf} n’est plus disponible.',
};
